"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const images_1 = require("../../services/images");
const react_1 = require("react");
const messageHandlers_1 = require("../../handlers/messageHandlers");
const ChatFooter = (props) => {
    const [input, setInput] = (0, react_1.useState)('');
    const handleKeyPress = (event) => {
        if (input != "") {
            if (!(event) || event.key === 'Enter') {
                if (event) {
                    event.preventDefault();
                }
                (0, messageHandlers_1.onMessageSend)({
                    input,
                    setInput,
                    initiatorId: props?.initiatorData?.id,
                    receiverId: props?.receiverData?.id,
                    user: props.user,
                    socket: props?.socket,
                    flightDataId: props.flightData?.id
                });
            }
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "chat-footer", children: [(0, jsx_runtime_1.jsx)("input", { className: "message-input", type: "text", disabled: props.reconnect, value: input, placeholder: "Message...", onChange: (event) => {
                    setInput(event.target.value);
                }, onKeyDown: handleKeyPress }), (0, jsx_runtime_1.jsx)("div", { className: "send-button", onClick: () => !props.reconnect && (0, messageHandlers_1.onMessageSend)({
                    input,
                    setInput,
                    initiatorId: props?.initiatorData?.id,
                    receiverId: props?.receiverData?.id,
                    user: props.user,
                    socket: props?.socket,
                    flightDataId: props.flightData?.id
                }), children: (0, jsx_runtime_1.jsx)("img", { src: images_1.icons.SendButton, alt: "send button" }) })] }));
};
exports.default = ChatFooter;
